import React from "react";
import { useMatchData } from "../../utils";
import {
  StyledMatchInfo,
  StyledMatchInfoTitle,
  StyledMatchInfoVenue,
  StyledMatchRoundInfo,
} from "./StyledMatchInfo";

export const MatchInfo = ({ roundInfo }) => {
  const { venue, leagueMatchTitle, competition } = useMatchData();
  const { name } = venue || {};

  return (
    <StyledMatchInfo className="mls-c-match-list__match-info">
      <StyledMatchInfoTitle>
        {leagueMatchTitle || competition?.name}
      </StyledMatchInfoTitle>
      <StyledMatchRoundInfo>{roundInfo}</StyledMatchRoundInfo>
      <StyledMatchInfoVenue>{name}</StyledMatchInfoVenue>
    </StyledMatchInfo>
  );
};
